import APP_CONSTANTS from "../../../utils/config";

// Save array data
export const setLocalStorageData = (key, data) => {
  if (!Array.isArray(data)) {
    console.error("Data must be an array");
    return;
  }

  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (err) {
    console.error("Error saving array:", err);
  }
};

// Fetch array data
export const getLocalStorageData = (key) => {
  try {
    const stored = localStorage.getItem(key);
    if (!stored) return [];

    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.error("Error fetching array:", err);
    return [];
  }
};

export const hasLocalStorageKey = (key) => {
  try {
    return localStorage.getItem(key) !== null;
  } catch (err) {
    console.error("Error checking localStorage key:", err);
    return false;
  }
};

export function isRestrictedKey(key, restricted_columns) {
  return restricted_columns.includes(key);
}

export function isTagKey(key, tag_columns) {
  return tag_columns.includes(key);
}

export function isLowConfidence(prob, threshold) {
  if (!prob || !threshold) return false;

  const p = parseFloat(prob);
  const t = parseFloat(threshold);

  if (isNaN(p) || isNaN(t)) return false;

  return p < t;
}

export function valueToString(v) {
  if (v === null || v === undefined) return "";
  if (Array.isArray(v)) return v.join(", ");
  return String(v);
}

export function parseTagValue(v) {
  if (Array.isArray(v)) return v;
  if (typeof v === "string" && v.trim() !== "") {
    try {
      const parsed = JSON.parse(v);
      if (Array.isArray(parsed)) return parsed;
    } catch (_) {
      // not valid JSON — treat the whole string as one tag
      try {
        const normalized = v.replace(/'/g, '"');
        const parsed = JSON.parse(normalized);

        if (Array.isArray(parsed)) return parsed;
      } catch (_) {
        // Treat as a single value
      }
    }
    return [v];
  }
  return [];
}

export function getParsedValue(column, value) {
  if (APP_CONSTANTS.TAG_COLUMNS.includes(column)) {
    {
      const newValue = parseTagValue(value);
      return newValue.join(", ");
    }
  } else {
    return value;
  }
}

export function isValidValue(value, columnName) {
  // Allow empty value while typing
  if (value === "") {
    return true;
  }

  if (APP_CONSTANTS.INT_COLUMNS.includes(columnName)) {
    return /^\d+$/.test(value);
  }

  if (APP_CONSTANTS.FLOAT_COLUMNS.includes(columnName)) {
    return /^\d*\.?\d*$/.test(value);
  }

  return true; // No restriction for other columns
}
